export default {
	next: '下一页',
	previous: '上一页'
};
